<template>
    <div>
        <div class="nav-wrapper is-dark" v-if="Object.keys(user).length && Object.keys(auth).length">
            <TheNavbar/>
        </div>
        <div class="custom-container">
            <div class="container height-inherit">
                <router-view/>
                <b-loading :is-full-page="false" :active="loading"></b-loading>
            </div>
        </div>
    </div>
</template>

<script>

    import TheNavbar from "@/components/Navbar";

    export default {
        name: "defaultLayout",
        components: {
            TheNavbar,
        },
        computed: {
            loading: {
                get() {
                    return this.$store.state.loading;
                },
                set(value) {
                    this.$store.commit("SET_LOADING", value);
                }
            },
            user(){
                return this.$store.state.user
            },
            auth() {
                return this.$store.state.auth
            }
        },
        watch:{
            $route:{
                immediate: true,
                handler(to) {
                    document.title = to.meta.title || "Service Station"
                }
            }
        }
    };

</script>